export const footerLayoutByVariant = {
  desktop: {
    linksGap: 48,
    pl: 156,
    pr: 156,
    socialButtonSize: 57,
  },
  laptop: {
    linksGap: 24,
    pl: 24,
    pr: 24,
    socialButtonSize: 57,
  },
  mobile: {
    linksGap: 32,
    pb: 9,
    pl: 16,
    pr: 16,
    pt: 32,
    socialButtonSize: 44,
  },
  tablet: {
    linksGap: 32,
    pb: 9,
    pl: 24,
    pr: 24,
    pt: 32,
    socialButtonSize: 44,
  },
};
